import materialAPI from './materialAPI'
import userAPI from './userAPI'
import toolAPI from './toolAPI'
import equipmentAPI from './equipmentAPI'
import sparepartAPI from './sparepartAPI'
import secondFloorAPI from './secondfloorAPI'
import welcomeAPI from './welcomeAPI'

export default{
    materialAPI,
    userAPI,
    toolAPI,
    equipmentAPI,
    sparepartAPI,
    secondFloorAPI,
    welcomeAPI
}


// WEBPACK FOOTER //
// ./src/api/index.js